type Row = Record<string, unknown>;
const record = (v: unknown): Row | null => v !== null && typeof v === 'object' && !Array.isArray(v) ? v as Row : null;

/** The identity fields a reference shell carries ({items:{item_id[, item_name, item_type]}}); a definition ROW carries more. */
const IDENTITY_ITEM_FIELDS = new Set(['item_id', 'item_name', 'item_type']);

/**
 * A HELD layer-less definition: the object-API payload's own markers, or — for a STATUS — the lean catalog row. The catalog IS the
 * definition store and drops an empty layer bucket, so {items:{item_created_by_id, …, item_description}, assets?} is the whole
 * status. Only a reference shell (identity fields alone) is unknown. Browser-compiled status rows embed no status_arr (2026-10-13),
 * so every layer-less status (Arcane Fatigue, Awake, Holding Mastery …) resolves through that row; rejecting it refused every
 * attack and skipped the AP refill of anyone carrying one. Callers accepting any carrier type
 * may opt into complete lean non-status rows too; identity shells still need a keyed read.
 */
export function heldLayerlessDefinition(def: Row | null | undefined, allowAnyType = false): boolean {
    const items = record(def?.items);
    if (!def || !items) return false;
    if ('item_layer_types' in def || !!record(def.computed) || !!record(def._meta)) return true;
    return (allowAnyType || items.item_type === 'status_effect') && Object.keys(items).some(key => !IDENTITY_ITEM_FIELDS.has(key));
}
